<template>
	<!DOCTYPE html>
	<html lang="ko">
	<head>
		<meta charset="UTF-8">
		<meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
		<meta http-equiv="X-UA-Compatible" content="IE=edge">
		<meta name="viewport" content="width=device-width, initial-scale=1.0">
		<title>상상플렉스</title>
		<link rel="stylesheet" href="/ssflex/assets/css/style-inicis.css">
		<link rel="preload" as="style" href="/ssflex/assets/css/app.min.css" onload="this.onload=null;this.rel='stylesheet'">
		<link rel="preload" as="style" href="/ssflex/assets/css/style.css" onload="this.onload=null;this.rel='stylesheet'">


	</head>
	<body>
	<!--	<body oncontextmenu="return false" ondragstart="return false" onselectstart="return false">-->

	<div id="wrap">

		<!--			<transition name="fade" mode="out-in">
						<router-view name="rv-app" :key="$route.fullPath"></router-view>
					</transition>-->

		<router-view name="rv-app"></router-view>

	</div>

	</body>

	<progress-bars></progress-bars>
	<!--	<vue-topprogress ref="topProgress" :speed="500" :height="5"></vue-topprogress>-->

	</html>

</template>

<script>

import commonsMixin from '@/commons/mixins/commons.mixin'
import sessionsMixin from '@/commons/mixins/sessions.mixin'

import Vue from "vue";
import vueTopprogress from 'vue-top-progress'
import ProgressBars from "@/commons/progressBars";

Vue.use(vueTopprogress)


export default {
	name: "App",
	components: {ProgressBars},
	mixins: [
		commonsMixin,
		sessionsMixin,
	],
	data() {

		return {
		}
	},
	created() {


		const self = this
		//this.setTitles("상상플렉스-BIM설계 올인원 플랫폼");


		// 백버튼 시 새로고침으로 동작변경
		window.onpopstate = () => {
			this.$nextTick(() => {
				// history.back()
				//location.reload()
				// self.created()
			})
		}


		/*this.$eventBus.$on("startProgress", ()=> {
			this.$refs.topProgress.start()
		})

		this.$eventBus.$on("doneProgress", ()=> {
			this.$refs.topProgress.done()
		})*/

	},
	mounted() {

		this.doSyncdate();
		this.doCheckTimeout();
	},
	updated() {

	},
	methods: {

		doCheckTimeout() {

			console.log(this.getLastTimes())
			setTimeout(() => {

				if (this.isLogin()) {
					this.isTimeout();
				}

				this.doCheckTimeout();
			}, (1000 * 60) * 1)
		}

	},
	watch: {
		'currentTimes': function (newVal) {
			console.log(newVal)
		}
	}
}
</script>

<style>
/*@import '/ssflex/assets/css/app.min.css';
@import '/ssflex/assets/css/style.css';
@import '/ssflex/assets/css/style-inicis.css';*/

.fade-enter-active,
.fade-leave-active {
	transition-duration: 0.3s;
	transition-property: opacity;
	transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0
}

</style>
